import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './components/Hero';
import ActivitySlider from './components/ActivitySlider';
import Courses from './components/Courses';
import Certification from './components/Certification';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import StarField from './components/StarField';
import Navbar from './components/Navbar';
import { useLang } from '../../i18n/LanguageContext';

export default function HomePage() {
  const { t } = useLang();
  const location = useLocation();

  useEffect(() => {
    const scrollTo = (location.state as { scrollTo?: string } | null)?.scrollTo;
    if (scrollTo) {
      const timer = setTimeout(() => {
        const el = document.getElementById(scrollTo);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-[#1a0b2e] via-[#2d1b4e] to-[#1a0b2e] overflow-hidden">
      <StarField />
      <Navbar />
      <Hero />
      <ActivitySlider />
      <Courses />
      <Certification />
      <Testimonials />

      <section id="community-faq" className="relative">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 pt-10 sm:pt-16 pb-4">
          <div className="text-center mb-10 sm:mb-12">
            <span className="inline-block px-4 py-1 rounded-full border border-[#d4af37]/40 text-[#d4af37] text-sm tracking-widest uppercase mb-4">
              {t('FAQ', '常见问题')}
            </span>
            <h2 className="text-3xl sm:text-5xl font-serif text-white mb-3">
              {t('Frequently Asked Questions', '常见问题解答')}
            </h2>
          </div>
        </div>
        <FAQ />
      </section>

      <Footer />
    </div>
  );
}